"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _tssReact = require("tss-react");
var _FormControlContext = _interopRequireWildcard(require("../FormControl/FormControlContext"));
var _formControlState = _interopRequireDefault(require("../FormControl/formControlState"));
var _tss = require("../styles/tss");
var _exposeClasses = require("../utilities/exposeClasses");
var _responsiveProps = require("../utilities/responsiveProps");
var _useForkRef = _interopRequireDefault(require("../utilities/useForkRef"));
var _useIsomorphicLayoutEffect = _interopRequireDefault(require("../utilities/useIsomorphicLayoutEffect"));
var _utils = require("./utils");
const _excluded = ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "defaultValue", "disabled", "endAdornment", "error", "exposeClasses", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "select", "startAdornment", "type", "value"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
const useStyles = (0, _tss.makeTssStyles)({
  name: 'DsInputBase',
  uniqId: 'Zd1APe'
})((theme, _params, classes) => {
  const {
    spacing
  } = theme.busbud;
  const inputStyle = theme.busbud.colors.component.textfield;
  const placeholderStyle = {
    color: inputStyle.normal.placeholder,
    lineHeight: 20 / 16
  };
  const placeholderFocusedStyle = {
    color: inputStyle.normal.placeholder,
    lineHeight: 20 / 16
  };
  const placeholderDisabledStyle = {
    color: inputStyle.disabled.placeholder,
    lineHeight: 20 / 16
  };
  const sizeCssDefinitions = {
    size: {
      md: {
        [`&:not(.${classes.textarea})`]: {
          height: spacing(6),
          [`&.${classes.expanded}`]: {
            height: spacing(7)
          }
        },
        [`&.${classes.expanded}`]: {
          margin: 0,
          [`& .${classes.input}`]: {
            paddingTop: spacing(3.25),
            paddingBottom: spacing(1)
          }
        },
        [`& .${classes.input}`]: _objectSpread(_objectSpread({
          padding: spacing(2.5, 0.5, 0.75, 1.5)
        }, theme.busbud.typography.font.component.label.lg), {}, {
          lineHeight: 20 / 16
        })
      },
      sm: {
        height: spacing(5),
        [`&.${classes.expanded}`]: {
          height: spacing(6),
          margin: 0,
          [`& .${classes.input}`]: {
            paddingTop: spacing(2.5),
            paddingBottom: spacing(0.5)
          }
        },
        [`& .${classes.input}`]: _objectSpread({
          padding: spacing(2, 0.5, 0.75, 1.5)
        }, theme.busbud.typography.font.component.label.md)
      }
    }
  };
  return _objectSpread({
    /* Styles applied to the root element. */
    root: {
      alignItems: 'center',
      display: 'inline-flex',
      transition: theme.transitions.create('', {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.easeInOut
      }),
      position: 'relative',
      color: inputStyle.normal.text,
      border: `1px solid transparent`,
      borderRadius: theme.busbud.styles.rounding.md,
      margin: spacing(0.5, 0),
      cursor: 'text',
      [`&.${classes.disabled}`]: {
        cursor: 'default'
      },
      '& svg': {
        flexShrink: 0
      },
      [`&:not(.${classes.focused}):not(.${classes.error}):hover`]: {
        border: `1px solid ${inputStyle.hover.border}`
      }
    },
    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: theme.busbud.spacing(1.5)
    },
    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: theme.busbud.spacing(1.5)
    },
    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {},
    /* Styles applied to the root element if the component is focused. */
    focused: {
      /* Increase specificity for exposedClasses to work */
      boxShadow: `0 0 0 2px ${inputStyle.normal.outline}`,
      border: `1px solid ${inputStyle.hover.border}`,
      color: inputStyle.normal.text,
      position: 'relative',
      zIndex: 1,
      [`& .${classes.input}`]: {
        '&::-webkit-input-placeholder': placeholderFocusedStyle,
        '&::-moz-placeholder': placeholderFocusedStyle,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholderFocusedStyle,
        // IE 11
        '&::-ms-input-placeholder': placeholderFocusedStyle // Edge
      }
    },
    /* Styles applied to the root element if input has a value. */
    filled: {
      color: inputStyle.normal.text
    },
    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {
      color: inputStyle.disabled.text,
      [`& .${classes.input}`]: {
        '&::-webkit-input-placeholder': placeholderDisabledStyle,
        '&::-moz-placeholder': placeholderDisabledStyle,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholderDisabledStyle,
        // IE 11
        '&::-ms-input-placeholder': placeholderDisabledStyle // Edge
      }
    },
    /* Styles applied to the root element if `error={true}`. */
    error: {
      /* Increase specificity for exposedClasses to work */
      '&&': {
        border: `1px solid ${inputStyle.error.border}`,
        [`&.${classes.focused}`]: {
          boxShadow: `0 0 0 2px ${inputStyle.errorFocused.outline}`,
          border: `1px solid ${inputStyle.error.border}`,
          color: inputStyle.error.label
        }
      }
    },
    expanded: {},
    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },
    /* Styles applied to the `input` element. */
    input: {
      transition: theme.transitions.create('', {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.easeInOut
      }),
      font: 'inherit',
      color: 'currentColor',
      border: 0,
      background: 'none',
      margin: 0,
      // Reset for Safari
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      display: 'block',
      // Make the flex item shrink with Firefox
      minWidth: 0,
      width: '100%',
      // Fix IE 11 width issue
      animationName: 'auto-fill-cancel',
      '&:focus': {
        outline: 0
      },
      // Reset Firefox invalid required input style
      '&:invalid': {
        boxShadow: 'none'
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        WebkitAppearance: 'none'
      },
      [`&.${classes.disabled}`]: {
        opacity: 1 // Reset iOS opacity
      },
      '&:-webkit-autofill': {
        animationDuration: '5000s',
        animationName: 'auto-fill'
      },
      '&::-webkit-input-placeholder': placeholderStyle,
      '&::-moz-placeholder': placeholderStyle,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholderStyle,
      // IE 11
      '&::-ms-input-placeholder': placeholderStyle // Edge
    },
    /* Styles applied to the `input` element if `select={true}`. */
    inputSelect: {},
    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },
    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    },
    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {
      // Improve type search style.
      MozAppearance: 'textfield',
      WebkitAppearance: 'textfield'
    },
    textarea: {
      resize: 'none'
    }
  }, (0, _responsiveProps.generateUnoptimizedResponsiveStyles)(theme, sizeCssDefinitions));
});
/**
 * **❗️ DEPRECATED**: Use the new `Input` component from `@busbud/horizon` - [Storybook](https://main--66e336a480b3d19fa782310f.chromatic.com/?path=/docs/forms-input):
 *
 * ```tsx
 * import { Input } from "@busbud/horizon";
 * ```
 *
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-api-inputbase--page)
 *
 * @deprecated
 */
const InputBase = /*#__PURE__*/_react.default.forwardRef(function InputBase(props, ref) {
  const {
      'aria-describedby': ariaDescribedby,
      autoComplete,
      autoFocus,
      classes: classesOverrides,
      className,
      defaultValue,
      disabled,
      endAdornment,
      error,
      exposeClasses,
      fullWidth = false,
      id,
      inputComponent,
      inputProps: inputPropsProp = {},
      inputRef: inputRefProp,
      multiline,
      name,
      onBlur,
      onChange,
      onClick,
      onFocus,
      onKeyDown,
      onKeyUp,
      placeholder,
      readOnly,
      renderSuffix,
      rows,
      select = false,
      startAdornment,
      type = 'text',
      value: valueProp
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes,
    cx
  } = useStyles(undefined, {
    props: {
      classes: classesOverrides
    }
  });
  const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
  const {
    current: isControlled
  } = _react.default.useRef(value != null);
  const inputRef = _react.default.useRef();
  const handleInputRefWarning = _react.default.useCallback(instance => {
    if (process.env.NODE_ENV !== 'production') {
      if (instance && !(instance instanceof HTMLInputElement) && !instance.focus) {
        console.error(['You have provided a `inputComponent` to the input component', 'that does not correctly handle the `inputRef` prop.', 'Make sure the `inputRef` prop is called with a HTMLInputElement.'].join('\n'));
      }
    }
  }, []);
  const handleInputPropsRefProp = (0, _useForkRef.default)(inputPropsProp.ref, handleInputRefWarning);
  const handleInputRefProp = (0, _useForkRef.default)(inputRefProp, handleInputPropsRefProp);
  const handleInputRef = (0, _useForkRef.default)(inputRef, handleInputRefProp);
  const [focused, setFocused] = _react.default.useState(false);
  const [textareaHeight, setTextareaHeight] = _react.default.useState(120);
  const dsFormControl = (0, _FormControlContext.useFormControl)();
  const fcs = (0, _formControlState.default)({
    props,
    dsFormControl,
    states: ['disabled', 'error', 'required', 'filled', 'size']
  });
  fcs.focused = dsFormControl ? dsFormControl.focused : focused;
  let expanded = false;
  if (dsFormControl) {
    expanded = dsFormControl.expanded || fcs.focused;
  }

  // The blur won't fire when the disabled state is set on a focused input.
  // We need to book keep the focused state manually.
  _react.default.useEffect(() => {
    if (!dsFormControl && disabled && focused) {
      setFocused(false);
      if (onBlur) {
        onBlur();
      }
    }
  }, [dsFormControl, disabled, focused, onBlur]);
  const onFilled = dsFormControl && dsFormControl.onFilled;
  const onEmpty = dsFormControl && dsFormControl.onEmpty;
  const checkDirty = _react.default.useCallback(obj => {
    if ((0, _utils.isFilled)(obj)) {
      if (onFilled) {
        onFilled();
      }
    } else if (onEmpty) {
      onEmpty();
    }
  }, [onFilled, onEmpty]);
  (0, _useIsomorphicLayoutEffect.default)(() => {
    if (isControlled) {
      checkDirty({
        value
      });
    }
  }, [value, checkDirty, isControlled]);
  const handleFocus = event => {
    // Fix a bug with IE 11 where the focus/blur events are triggered
    // while the input is disabled.
    if (fcs.disabled) {
      event.stopPropagation();
      return;
    }
    if (onFocus) {
      onFocus(event);
    }
    if (inputPropsProp.onFocus) {
      inputPropsProp.onFocus(event);
    }
    if (dsFormControl && dsFormControl.onFocus) {
      dsFormControl.onFocus(event);
    } else {
      setFocused(true);
    }
  };
  const handleBlur = event => {
    if (onBlur) {
      onBlur(event);
    }
    if (inputPropsProp.onBlur) {
      inputPropsProp.onBlur(event);
    }
    if (dsFormControl && dsFormControl.onBlur) {
      dsFormControl.onBlur(event);
    } else {
      setFocused(false);
    }
  };
  const handleChange = function (event) {
    if (!isControlled) {
      const element = event.target || inputRef.current;
      if (element == null) {
        throw new TypeError('DSCL: Expected valid input target. ' + 'Did you use a custom `inputComponent` and forget to forward refs? ' + 'See https://material-ui.com/r/input-component-ref-interface for more info.');
      }
      checkDirty({
        value: element.value
      });
    }
    if (multiline && inputRef.current) {
      //@ts-ignore
      const scrollHeight = inputRef.current.scrollHeight || 0;
      if (Math.max(scrollHeight, 120) !== textareaHeight) {
        setTextareaHeight(scrollHeight);
      }
    }
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    if (inputPropsProp.onChange) {
      inputPropsProp.onChange(event, ...args);
    }

    // Perform in the willUpdate
    if (onChange) {
      onChange(event, ...args);
    }
  };

  // Check the input state on mount, in case it was filled by the user
  // or auto filled by the browser before the hydration (for SSR).
  _react.default.useEffect(() => {
    checkDirty(inputRef.current);
  }, []);
  const handleClick = event => {
    if (inputRef.current && event.currentTarget === event.target) {
      // @ts-ignore - inputRef.current is checked above
      inputRef.current.focus();
    }
    if (onClick) {
      onClick(event);
    }
  };
  const defaultInputComponent = multiline ? 'textarea' : 'input';
  const InputComponent = inputComponent || defaultInputComponent;
  let inputProps = _objectSpread(_objectSpread({}, inputPropsProp), {}, {
    ref: handleInputRef
  });
  if (typeof InputComponent !== 'string') {
    inputProps = _objectSpread(_objectSpread({
      // Rename ref to inputRef as we don't know the
      // provided `inputComponent` structure.
      inputRef: handleInputRef,
      type
    }, inputProps), {}, {
      ref: null
    });
  } else {
    inputProps = _objectSpread({
      type
    }, inputProps);
  }
  const handleAutoFill = event => {
    // Provide a fake value as Chrome might not let you access it for security reasons.
    checkDirty(event.animationName.indexOf('auto-fill-cancel') !== -1 ? inputRef.current : {
      value: 'x'
    });
  };
  const sizeClasses = (0, _responsiveProps.getResponsiveClassNamesForProp)(fcs.size || 'md', 'size').map(classe => classes[classe]);
  const autoExpandArea = multiline ? {
    height: `${textareaHeight}px`
  } : {};
  const exposedClassesAttributes = exposeClasses ? (0, _exposeClasses.getExposedClasses)('DsInputBase', classes, ['disabled', 'error', 'focused']) : {};
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_tssReact.GlobalStyles, {
    styles: {
      '@keyframes auto-fill': {},
      '@keyframes auto-fill-cancel': {},
      /* clears the ‘X’ from Internet Explorer */
      'input[type=search]::-ms-clear': {
        display: 'none',
        width: 0,
        height: 0
      },
      'input[type=search]::-ms-reveal': {
        display: 'none',
        width: 0,
        height: 0
      },
      /* clears the ‘X’ from Chrome */
      'input[type=search]::-webkit-search-decoration, input[type=search]::-webkit-search-cancel-button, input[type=search]::-webkit-search-results-button, input[type=search]::-webkit-search-results-decoration': {
        display: 'none'
      }
    }
  }), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, exposedClassesAttributes, {
    className: cx(classes.root, {
      [classes.disabled]: fcs.disabled,
      [classes.error]: fcs.error,
      [classes.expanded]: expanded,
      [classes.fullWidth]: fullWidth,
      [classes.filled]: fcs.filled,
      [classes.focused]: fcs.focused,
      [classes.formControl]: !!dsFormControl,
      [classes.adornedEnd]: !!endAdornment,
      [classes.adornedStart]: !!startAdornment,
      [classes.textarea]: multiline
    }, ...sizeClasses, className),
    onClick: handleClick,
    ref: ref
  }, other), startAdornment, /*#__PURE__*/_react.default.createElement(_FormControlContext.default.Provider, {
    value: fcs
  }, /*#__PURE__*/_react.default.createElement(InputComponent, (0, _extends2.default)({
    "aria-invalid": fcs.error,
    "aria-describedby": ariaDescribedby,
    autoComplete: autoComplete
    // eslint-disable-next-line jsx-a11y/no-autofocus -- TODO: [fix-jsx-a11y]
    ,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    disabled: fcs.disabled,
    id: id,
    onAnimationStart: handleAutoFill,
    name: name
  }, expanded ? {
    placeholder: placeholder
  } : {}, {
    readOnly: readOnly,
    required: fcs.required,
    rows: rows,
    value: value,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp
  }, inputProps, {
    className: cx(classes.input, {
      [classes.disabled]: fcs.disabled,
      [classes.inputTypeSearch]: type === 'search',
      [classes.inputSelect]: select,
      [classes.inputAdornedStart]: !!startAdornment,
      [classes.inputAdornedEnd]: !!endAdornment,
      [classes.textarea]: multiline
    }, inputPropsProp.className),
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus,
    style: autoExpandArea
  }))), endAdornment, renderSuffix ? renderSuffix(_objectSpread(_objectSpread({}, fcs), {}, {
    startAdornment
  })) : null));
});

// @ts-ignore
InputBase.dsName = 'Input';
var _default = exports.default = InputBase;